// extracted by mini-css-extract-plugin
export var alignCenter = "_6m-d";
export var bannerShown = "_6m-6";
export var buttonContent = "_6m-0";
export var cardList = "_6m-1";
export var centerContent = "_6m-2";
export var chevron = "_6m-3";
export var closePanelButton = "_6m-k";
export var conversationContextContainer = "_6m-l";
export var conversationDetailContainer = "_6m-4";
export var detailWrapper = "_6m-7";
export var dropdownButton = "_6m-e";
export var dropdownTitle = "_6m-9";
export var fullHeight = "_6m-5";
export var hidden = "_6m-a";
export var icon = "_6m-b";
export var mergeSuggestionWrapper = "_6m-m";
export var panel = "_6m-i";
export var portalButtonsWrapper = "_6m-c";
export var right = "_6m-j";
export var tableSummaryContainer = "_6m-8";
export var tableSummaryHeader = "_6m-g";
export var threeDotsButton = "_6m-f";
export var wide = "_6m-h";